// extracted by mini-css-extract-plugin
export default {"container":"events_container__-pL0P","calendar_icon":"events_calendar_icon__Tow1M"};